import { dynamicSearch } from './dynamic-search';

export const dynamicSearchAdTemplates = [
  dynamicSearch,
];
